export default "__VITE_ASSET__B1zZb38a__"